
import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/recepcion/ParteInterface';
import { TipoPrestacionProps } from '../../interfaces/catalogos/TipoPrestacionInterface';

import { AgregarPartesExpedienteParams, AgregarPrestacionesExpedienteParams, BuscarExpedienteAnteriorParams, BuscarExpedienteParams, BuscarExpedienteResponse, ConsultaExpedienteEtapaParams, ConsultaExpedienteEtapaResponse, DescargarExpedientesEtapaProcesalParams, defaultConsultaExpedienteEtapa, defaultExpedienteAnteriorResponse, defaultExpedienteResponse, defaultGenerarCaratula, EditarExpedienteParams, ExpedienteAnteriorResponse, GenerarCaratulaResponse, GuardarExpedienteAnteriorParams, DigitalizacionProps } from '../../interfaces/recepcion/ExpedienteInterface';

export const BuscarExpediente = ( params: BuscarExpedienteParams ) => {

    return new Promise<BuscarExpedienteResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/BuscarExpediente', params, token)
            .then( ({ data } : { data : BuscarExpedienteResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultExpedienteResponse });
            });

        }

    });

}

export const BuscarExpedienteAnterior = ( params: BuscarExpedienteAnteriorParams ) => {

    return new Promise<ExpedienteAnteriorResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/BuscarExpedienteAnterior', params, token)
            .then( ({ data } : { data : ExpedienteAnteriorResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultExpedienteAnteriorResponse });
            });

        }

    });

}

export const GuardarExpedienteAnterior = ( params: GuardarExpedienteAnteriorParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/GuardarExpedienteAnterior', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerDigitalizacion = ( id: number ) => {

    return new Promise<DigitalizacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Expediente/ObtenerDigitalizacion/${ id }`, token)
            .then( ({ data } : { data : DigitalizacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const GenerarCaratulaExpediente = ( idExpediente: number ) => {

    return new Promise<GenerarCaratulaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Expediente/GenerarCaratula/${ idExpediente }`, token)
            .then( ({ data } : { data : GenerarCaratulaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarCaratula, message: error.message } );
            });

        }

    });

}

export const EliminarCaratulaExpediente = ( idExpediente: number ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Expediente/EliminarCaratula/${ idExpediente }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPartesExpediente = ( id: number ) => {

    return new Promise<ParteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Expediente/ObtenerPartesExpediente/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const EditarExpediente = ( params: EditarExpedienteParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/EditarExpediente', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPrestacionesExpediente = ( id: number ) => {

    return new Promise<TipoPrestacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Expediente/ObtenerPrestacionesExpediente/${ id }`, token)
            .then( ({ data } : { data : TipoPrestacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPartesExpediente = ( params: AgregarPartesExpedienteParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/AgregarPartesExpediente/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const AgregarPrestacionesExpediente = ( params: AgregarPrestacionesExpedienteParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/AgregarPrestacionesExpediente', params, token)
            .then( () => {
                resolve({ success: true, message: 'Se actualizaron las prestaciones correctamente' });
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ConsultarExpedientesEtapaProcesal = ( params: ConsultaExpedienteEtapaParams ) => {

    return new Promise<ConsultaExpedienteEtapaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Expediente/ConsultarExpedientesEtapaProcesal', params, token)
            .then( ({ data } : { data : ConsultaExpedienteEtapaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsultaExpedienteEtapa } );
            });

        }

    });

}

export const DescargarExpedientesEtapaProcesal = ( params: DescargarExpedientesEtapaProcesalParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/Expediente/DescargarExpedientesEtapaProcesal', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
